import useAddressAutocomplete, {
    type Suggestion,
    type AddressDetails,
} from '../src/hooks/useAddressAutocomplete.ts';

export default useAddressAutocomplete;

export type { Suggestion, AddressDetails };
